import React from "react";
import Pagination, { usePagination, TableScroller } from "./Pagination";

/**
 * Paginated — client-side pagination wrapper used across the CRM
 * (Orders, WhatsApp templates, Festival CRM, Predictive CRM, Data Migration,
 * Astrology …).
 *
 *   <Paginated items={list} pageSize={15}>
 *     {(pageItems) => pageItems.map(...)}
 *   </Paginated>
 *
 * This is a thin wrapper over the shared usePagination/Pagination pair so the
 * whole app has ONE pagination implementation and one look. The render-prop
 * API is unchanged, so existing call sites keep working.
 *
 * Options:
 *   topControls — also show page controls ABOVE the content (default true), so
 *                 you don't have to scroll to the bottom to change page.
 *   scroller    — wrap the content in a TableScroller, adding a second
 *                 horizontal scrollbar at the top for wide tables.
 */
export default function Paginated({
  items = [],
  pageSize = 15,
  children,
  className = "",
  label = "rows",
  topControls = true,
  scroller = false,
}) {
  const pg = usePagination(items, pageSize);
  const body = children(pg.pageItems, pg.page);

  return (
    <div className={className}>
      {topControls && items.length > pageSize && (
        <Pagination {...pg} label={label} compact />
      )}
      {scroller ? <TableScroller>{body}</TableScroller> : body}
      {items.length > pageSize && <Pagination {...pg} label={label} />}
    </div>
  );
}
